/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefType1
 */
export interface RefType1 {
}

/**
 * Check if a given object implements the RefType1 interface.
 */
export function instanceOfRefType1(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RefType1FromJSON(json: any): RefType1 {
    return RefType1FromJSONTyped(json, false);
}

export function RefType1FromJSONTyped(json: any, ignoreDiscriminator: boolean): RefType1 {
    return json;
}

export function RefType1ToJSON(value?: RefType1 | null): any {
    return value;
}

